/**
 * The Urs Shop - Product Enhancements JS Module
 * Manages:
 * 1. Side popup video drawer, audio controls & video add-to-cart
 * 2. Saree tailoring customizations, sizing & line item properties
 * 3. Self-generated reviews, rating modal & localStorage persistence
 * 4. Sticky bottom add to cart bar
 * 5. Indian pincode delivery estimator
 */

(function () {
  'use strict';

  function initProductEnhancements() {
    initSideVideoPopup();
    initSareeCustomizations();
    initSelfGeneratedReviews();
    initStickyBar();
    initPincodeChecker();
    initMeasurementGuide();
  }

  /* --------------------------------------------------------------------------
     1. SIDE POPUP VIDEO
     -------------------------------------------------------------------------- */
  function initSideVideoPopup() {
    const trigger = document.getElementById('ursVideoTrigger');
    const modal = document.getElementById('ursVideoModal');
    const closeBtn = document.getElementById('ursVideoCloseBtn');
    const video = document.getElementById('ursReelVideo');
    const muteBtn = document.getElementById('ursVideoMuteBtn');
    const playBtn = document.getElementById('ursVideoPlayBtn');
    const ctaBtn = document.getElementById('ursVideoCtaBtn');

    if (!trigger || !modal || !video) return;

    function openVideoModal() {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      video.play().catch(function(e) {
        console.log('Autoplay deferred:', e);
      });
    }

    function closeVideoModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      video.pause();
    }

    trigger.addEventListener('click', openVideoModal);

    if (closeBtn) {
      closeBtn.addEventListener('click', closeVideoModal);
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeVideoModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeVideoModal();
      }
    });

    // Mute / Unmute
    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        const icon = muteBtn.querySelector('svg');
        if (video.muted) {
          muteBtn.setAttribute('aria-label', 'Unmute');
          muteBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
            </svg>`;
        } else {
          muteBtn.setAttribute('aria-label', 'Mute');
          muteBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
            </svg>`;
        }
      });
    }

    // Play / Pause
    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) {
          video.play();
          playBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
            </svg>`;
        } else {
          video.pause();
          playBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z"/>
            </svg>`;
        }
      });
    }

    // Video CTA Add To Bag trigger
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        closeVideoModal();
        const mainAddToCart = document.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]') ||
                              document.querySelector('form[data-type="add-to-cart-form"] .product-form-buttons button') ||
                              document.querySelector('.product-details button[type="submit"]');
        if (mainAddToCart) {
          mainAddToCart.click();
        }
      });
    }
  }

  /* --------------------------------------------------------------------------
     2. SAREE TAILORING & CUSTOMIZATIONS
     -------------------------------------------------------------------------- */
  function initSareeCustomizations() {
    const container = document.getElementById('ursSareeCustomizations');
    if (!container) return;

    const basePrice = parseFloat(container.dataset.basePrice || '0');
    const fallCheckbox = document.getElementById('ursCustomFallPico');
    const tasselsCheckbox = document.getElementById('ursCustomTassels');
    const blouseCheckbox = document.getElementById('ursCustomBlouse');
    const rtwCheckbox = document.getElementById('ursCustomRtw');

    const blousePanel = container.querySelector('.urs-blouse-options-panel');
    const blouseTypeBtns = container.querySelectorAll('.urs-blouse-type-btn');
    const blouseSizeChips = container.querySelectorAll('.urs-blouse-size-chip');
    const customFields = container.querySelector('.urs-custom-measurements-grid');
    const summaryAmount = document.getElementById('ursCustomTotalAmount');

    // Hidden Line item property inputs bound to product form
    const propFall = document.getElementById('propFallPico');
    const propTassels = document.getElementById('propTassels');
    const propBlouse = document.getElementById('propBlouse');
    const propRtw = document.getElementById('propRtw');

    let currentBlouseType = 'Standard Stitched';
    let currentBlouseSize = '38';

    function recalculateTotal() {
      let extra = 0;

      if (fallCheckbox && fallCheckbox.checked) {
        const fallPrice = parseFloat(fallCheckbox.dataset.price || '199');
        extra += fallPrice;
        if (propFall) propFall.value = `Fall & Pico Finishing (+₹${fallPrice})`;
        fallCheckbox.closest('.urs-customization-card').classList.add('is-active');
      } else {
        if (propFall) propFall.value = '';
        if (fallCheckbox) fallCheckbox.closest('.urs-customization-card').classList.remove('is-active');
      }

      if (tasselsCheckbox && tasselsCheckbox.checked) {
        const tasselsPrice = parseFloat(tasselsCheckbox.dataset.price || '249');
        extra += tasselsPrice;
        if (propTassels) propTassels.value = `Handcrafted Silk Thread Tassels (+₹${tasselsPrice})`;
        tasselsCheckbox.closest('.urs-customization-card').classList.add('is-active');
      } else {
        if (propTassels) propTassels.value = '';
        if (tasselsCheckbox) tasselsCheckbox.closest('.urs-customization-card').classList.remove('is-active');
      }

      if (blouseCheckbox && blouseCheckbox.checked) {
        blouseCheckbox.closest('.urs-customization-card').classList.add('is-active');
        if (currentBlouseType === 'Custom Tailored') {
          const customPrice = parseFloat(blouseCheckbox.dataset.customPrice || '1500');
          extra += customPrice;
          const bBust = document.getElementById('ursMeasureBust')?.value || '';
          const bWaist = document.getElementById('ursMeasureWaist')?.value || '';
          const bLength = document.getElementById('ursMeasureLength')?.value || '';
          if (propBlouse) {
            propBlouse.value = `Custom Tailored (Bust: ${bBust || '38'}", Waist: ${bWaist || '32'}", Length: ${bLength || '14'}") (+₹${customPrice})`;
          }
        } else {
          const stdPrice = parseFloat(blouseCheckbox.dataset.price || '1200');
          extra += stdPrice;
          if (propBlouse) propBlouse.value = `Standard Stitched (Size ${currentBlouseSize}) (+₹${stdPrice})`;
        }
      } else {
        if (propBlouse) propBlouse.value = 'Unstitched Blouse Piece (Included)';
        if (blouseCheckbox) blouseCheckbox.closest('.urs-customization-card').classList.remove('is-active');
      }

      if (rtwCheckbox && rtwCheckbox.checked) {
        const rtwPrice = parseFloat(rtwCheckbox.dataset.price || '499');
        extra += rtwPrice;
        const rtwWaist = document.getElementById('ursRtwWaistSelect')?.value || '32';
        if (propRtw) propRtw.value = `Yes (Pre-pleated with hooks, Waist ${rtwWaist}") (+₹${rtwPrice})`;
        rtwCheckbox.closest('.urs-customization-card').classList.add('is-active');
      } else {
        if (propRtw) propRtw.value = '';
        if (rtwCheckbox) rtwCheckbox.closest('.urs-customization-card').classList.remove('is-active');
      }

      if (summaryAmount) {
        const total = basePrice + extra;
        summaryAmount.textContent = `₹${total.toLocaleString('en-IN')}`;
      }
    }

    [fallCheckbox, tasselsCheckbox, blouseCheckbox, rtwCheckbox].forEach(function (cb) {
      if (cb) {
        cb.addEventListener('change', recalculateTotal);
      }
    });

    // Blouse Type Toggle
    blouseTypeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        blouseTypeBtns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        currentBlouseType = btn.dataset.type;

        if (currentBlouseType === 'Custom Tailored') {
          if (customFields) customFields.style.display = 'grid';
          const sizeRow = container.querySelector('.urs-blouse-sizes-row');
          if (sizeRow) sizeRow.style.display = 'none';
        } else {
          if (customFields) customFields.style.display = 'none';
          const sizeRow = container.querySelector('.urs-blouse-sizes-row');
          if (sizeRow) sizeRow.style.display = 'flex';
        }
        recalculateTotal();
      });
    });

    // Blouse Size Chips
    blouseSizeChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        blouseSizeChips.forEach(c => c.classList.remove('is-selected'));
        chip.classList.add('is-selected');
        currentBlouseSize = chip.dataset.size;
        recalculateTotal();
      });
    });

    // Measurement inputs
    const measureInputs = container.querySelectorAll('.urs-measure-field input');
    measureInputs.forEach(function (inp) {
      inp.addEventListener('input', recalculateTotal);
    });

    const rtwSelect = document.getElementById('ursRtwWaistSelect');
    if (rtwSelect) {
      rtwSelect.addEventListener('change', recalculateTotal);
    }

    window.URS_GET_SELECTED_ADDONS = function (quantity) {
      if (!container || !document.body.contains(container) || container.style.display === 'none') {
        return [];
      }
      const qty = Number(quantity) || 1;
      const addons = [];
      const rawTitle = container.dataset.sareeTitle || document.querySelector('.product-details h1')?.textContent || 'Handcrafted Saree';
      const sareeTitle = rawTitle.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

      // 1. Fall & Pico
      if (fallCheckbox && fallCheckbox.checked) {
        const variantId = container.dataset.fallVariant || '54631796343094';
        addons.push({
          id: Number(variantId),
          quantity: qty,
          properties: {
            'For Saree': sareeTitle
          }
        });
      }

      // 2. Tassels
      if (tasselsCheckbox && tasselsCheckbox.checked) {
        const variantId = container.dataset.tasselsVariant || '54631796375862';
        addons.push({
          id: Number(variantId),
          quantity: qty,
          properties: {
            'For Saree': sareeTitle
          }
        });
      }

      // 3. Blouse Stitching
      if (blouseCheckbox && blouseCheckbox.checked) {
        if (currentBlouseType === 'Custom Tailored') {
          const variantId = container.dataset.blouseCustomVariant || '54631796441398';
          const bBust = document.getElementById('ursMeasureBust')?.value || '38';
          const bWaist = document.getElementById('ursMeasureWaist')?.value || '32';
          const bLength = document.getElementById('ursMeasureLength')?.value || '14';
          const bNeck = document.getElementById('ursMeasureNeck')?.value || '7';
          addons.push({
            id: Number(variantId),
            quantity: qty,
            properties: {
              'For Saree': sareeTitle,
              'Custom Measurements': `Bust: ${bBust}", Waist: ${bWaist}", Length: ${bLength}", Front Neck: ${bNeck}"`
            }
          });
        } else {
          const variantId = container.dataset.blouseStdVariant || '54631796408630';
          addons.push({
            id: Number(variantId),
            quantity: qty,
            properties: {
              'For Saree': sareeTitle,
              'Blouse Size': `${currentBlouseSize} inches`
            }
          });
        }
      }

      // 4. Ready to Wear
      if (rtwCheckbox && rtwCheckbox.checked) {
        const variantId = container.dataset.rtwVariant || '54631796474166';
        const rtwWaist = document.getElementById('ursRtwWaistSelect')?.value || '32';
        addons.push({
          id: Number(variantId),
          quantity: qty,
          properties: {
            'For Saree': sareeTitle,
            'Waist Size': `${rtwWaist} inches`
          }
        });
      }

      return addons;
    };

    recalculateTotal();
  }

  /* --------------------------------------------------------------------------
     3. SELF-GENERATED REVIEWS & APP SWITCHER
     -------------------------------------------------------------------------- */
  function initSelfGeneratedReviews() {
    const writeBtn = document.getElementById('ursWriteReviewBtn');
    const modal = document.getElementById('ursReviewModal');
    const closeBtn = document.getElementById('ursReviewModalClose');
    const form = document.getElementById('ursReviewForm');
    const starItems = document.querySelectorAll('.urs-star-rating-picker .star-item');
    const ratingInput = document.getElementById('ursReviewScoreInput');
    const reviewsGrid = document.getElementById('ursReviewsGrid');

    // Scroll to reviews from top badge
    const topBadge = document.getElementById('ursTopRatingBadge');
    if (topBadge) {
      topBadge.addEventListener('click', function () {
        const revSec = document.getElementById('productReviewsSection');
        if (revSec) {
          revSec.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    if (!writeBtn || !modal) return;

    writeBtn.addEventListener('click', function () {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    function closeReviewModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeReviewModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeReviewModal();
    });

    // Star Picker Interaction
    let selectedRating = 5;
    starItems.forEach(function (star) {
      star.addEventListener('mouseover', function () {
        const val = parseInt(star.dataset.val, 10);
        starItems.forEach((s, idx) => {
          s.classList.toggle('is-hovered', idx < val);
        });
      });

      star.addEventListener('mouseout', function () {
        starItems.forEach(s => s.classList.remove('is-hovered'));
      });

      star.addEventListener('click', function () {
        selectedRating = parseInt(star.dataset.val, 10);
        if (ratingInput) ratingInput.value = selectedRating;
        starItems.forEach((s, idx) => {
          s.classList.toggle('is-active', idx < selectedRating);
        });
      });
    });

    // Render Saved Reviews from LocalStorage
    const storageKey = 'urs_product_reviews_' + (window.__URS_PRODUCT_ID || 'general');
    function loadSavedReviews() {
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
        saved.forEach(function (rev) {
          renderSingleReview(rev, true);
        });
      } catch (err) {
        console.error('Error loading reviews:', err);
      }
    }

    function renderSingleReview(rev, prepend) {
      if (!reviewsGrid) return;
      const card = document.createElement('div');
      card.className = 'urs-review-card';
      const initial = (rev.name || 'C').charAt(0).toUpperCase();
      const starsStr = '★'.repeat(rev.rating) + '☆'.repeat(5 - rev.rating);

      card.innerHTML = `
        <div class="urs-review-card-header">
          <div class="urs-review-author">
            <div class="urs-author-avatar">${initial}</div>
            <div>
              <div class="urs-author-name">${escapeHtml(rev.name)}</div>
              <div class="urs-review-meta">${escapeHtml(rev.city || 'Verified Customer')} • ${escapeHtml(rev.date || 'Just now')}</div>
            </div>
          </div>
          <span class="urs-review-verified-tag">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg> Verified
          </span>
        </div>
        <div class="urs-review-stars">${starsStr}</div>
        <div class="urs-review-title">${escapeHtml(rev.title)}</div>
        <div class="urs-review-body">${escapeHtml(rev.body)}</div>
        <div class="urs-review-item-tag">✓ Purchased: Handcrafted Banarasi Saree</div>
      `;

      if (prepend) {
        reviewsGrid.insertBefore(card, reviewsGrid.firstChild);
      } else {
        reviewsGrid.appendChild(card);
      }
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str).replace(/[&<>"']/g, function(m) {
        return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[m];
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const name = document.getElementById('ursReviewerName')?.value || 'Customer';
        const city = document.getElementById('ursReviewerCity')?.value || 'India';
        const title = document.getElementById('ursReviewTitle')?.value || 'Delighted with the Saree';
        const body = document.getElementById('ursReviewBody')?.value || '';

        const newRev = {
          name: name,
          city: city,
          title: title,
          body: body,
          rating: selectedRating,
          date: 'Today'
        };

        try {
          const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
          saved.unshift(newRev);
          localStorage.setItem(storageKey, JSON.stringify(saved));
        } catch (err) {}

        renderSingleReview(newRev, true);
        form.reset();
        closeReviewModal();

        // Thank you notification
        alert('Thank you for sharing your review! It has been posted.');
      });
    }

    loadSavedReviews();
  }

  /* --------------------------------------------------------------------------
     4. STICKY BOTTOM ADD TO CART BAR
     -------------------------------------------------------------------------- */
  function initStickyBar() {
    const stickyBar = document.getElementById('ursStickyBar');
    const mainBuyForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!stickyBar || !mainBuyForm) return;

    const stickyBtn = document.getElementById('ursStickyAddBtn');

    window.addEventListener('scroll', function () {
      const rect = mainBuyForm.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBar.classList.add('is-active');
      } else {
        stickyBar.classList.remove('is-active');
      }
    }, { passive: true });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        const mainBtn = mainBuyForm.querySelector('button[type="submit"]') ||
                        mainBuyForm.querySelector('.product-form-buttons button');
        if (mainBtn) {
          mainBtn.click();
        } else {
          mainBuyForm.submit();
        }
      });
    }
  }

  /* --------------------------------------------------------------------------
     5. INDIAN PINCODE ESTIMATOR
     -------------------------------------------------------------------------- */
  function initPincodeChecker() {
    const btn = document.getElementById('ursPincodeCheckBtn');
    const input = document.getElementById('ursPincodeInput');
    const result = document.getElementById('ursPincodeResult');

    if (!btn || !input || !result) return;

    btn.addEventListener('click', function () {
      const pin = input.value.trim();
      if (!/^\d{6}$/.test(pin)) {
        result.className = 'urs-pincode-result is-visible';
        result.style.color = '#c62828';
        result.innerHTML = '⚠️ Please enter a valid 6-digit Indian PIN code';
        return;
      }

      // Calculate estimated date (+ 4 business days)
      const date = new Date();
      date.setDate(date.getDate() + 4);
      const options = { weekday: 'short', month: 'short', day: 'numeric' };
      const dateStr = date.toLocaleDateString('en-IN', options);

      result.className = 'urs-pincode-result is-visible is-success';
      result.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        <span>Delivery available to <strong>${pin}</strong> by <strong>${dateStr}</strong> (Free Insured Express)</span>
      `;
    });
  }

  /* --------------------------------------------------------------------------
     6. MEASUREMENT GUIDE MODAL
     -------------------------------------------------------------------------- */
  function initMeasurementGuide() {
    const trigger = document.getElementById('ursOpenGuideBtn');
    const modal = document.getElementById('ursGuideModal');
    const closeBtn = document.getElementById('ursGuideCloseBtn');

    if (!trigger || !modal) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    function closeGuide() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeGuide);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeGuide();
    });
  }

  // Self execute when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductEnhancements);
  } else {
    initProductEnhancements();
  }
})();
